import { Route, Routes } from "react-router-dom";
import { CatalogPourbackProvider } from "./context/CatalogPourbackContext";
import { CatalogPourbackPage } from "./pages/CatalogPourbackPage";

type Props = {};
const CatalogPourbackReason = (props: Props) => {
  return (
    <CatalogPourbackProvider>
      <Routes>
        <Route index element={<CatalogPourbackPage />}></Route>
        <Route
          path=":pourbackReasonId"
          element={<CatalogPourbackPage />}
        ></Route>
      </Routes>
    </CatalogPourbackProvider>
  );
};
export default CatalogPourbackReason;
